module.exports = __webpack_public_path__ + "static/media/q_type_4.0bbf02d1.png";